import withTracking from './with-tracking-hoc'

export default withTracking
